var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _path5, _path6, _linearGradient4, _circle, _path7, _path8, _linearGradient5, _circle2, _linearGradient6, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa",
    gradientUnits: "userSpaceOnUse",
    x1: -1364.508,
    y1: -484.509,
    x2: -1363.508,
    y2: -484.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M99.463 120.942a5.042 5.042 0 01-5.027-5.027v-80.27a5.042 5.042 0 015.027-5.027 5.042 5.042 0 015.027 5.027v80.27a5.042 5.042 0 01-5.027 5.027zM67.031 128.723v-6.65l27.4-11.42M104.491 110.473l27.83 11.6v6.65"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa",
    gradientUnits: "userSpaceOnUse",
    x1: 103.241,
    y1: 39.748,
    x2: 153.951,
    y2: 39.748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.701 36.143a7.19 7.19 0 01-6.23 7.13c-.32.06-.65.08-.98.08-.61 0-1.19-.07-1.75-.22a7.199 7.199 0 01-5.47-6.99h-33.78",
    fill: "none",
    stroke: "url(#SVGID_1_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa",
    gradientUnits: "userSpaceOnUse",
    x1: 45.671,
    y1: 39.748,
    x2: 95.681,
    y2: 39.748
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.431 36.143h-33.08c0 3.63-2.69 6.64-6.18 7.13-.34.05-.68.08-1.03.08-.59 0-1.16-.07-1.7-.21a7.205 7.205 0 01-5.52-7",
    fill: "none",
    stroke: "url(#SVGID_2_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M30.154 99.537l23.627-59.788 23.628 59.788M121.451 99.537l23.627-59.788 23.628 59.788"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M147.826 83.393s-.487-2.817-2.817-2.817-2.956 2.817-2.956 2.817l6.051 4.588M142.331 87.981s.487 2.817 2.817 2.817 2.956-2.817 2.956-2.817M145.078 78.177v2.4M145.078 90.798v2.4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M147.826 83.393s-.487-2.817-2.817-2.817-2.956 2.817-2.956 2.817l6.051 4.588M142.331 87.981s.487 2.817 2.817 2.817 2.956-2.817 2.956-2.817M145.078 78.177v2.4M145.078 90.798v2.4"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa",
    gradientUnits: "userSpaceOnUse",
    x1: 130.207,
    y1: 85.547,
    x2: 159.95,
    y2: 85.547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 145.078,
    cy: 85.547,
    r: 13.621,
    fill: "none",
    stroke: "url(#SVGID_3_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M56.498 83.393s-.487-2.817-2.817-2.817-2.956 2.817-2.956 2.817l6.051 4.588M51.003 87.981s.487 2.817 2.817 2.817 2.956-2.817 2.956-2.817M53.75 78.177v2.4M53.75 90.798v2.4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M56.498 83.393s-.487-2.817-2.817-2.817-2.956 2.817-2.956 2.817l6.051 4.588M51.003 87.981s.487 2.817 2.817 2.817 2.956-2.817 2.956-2.817M53.75 78.177v2.4M53.75 90.798v2.4"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa",
    gradientUnits: "userSpaceOnUse",
    x1: 38.879,
    y1: 85.547,
    x2: 68.621,
    y2: 85.547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.75,
    cy: 85.547,
    r: 13.621,
    fill: "none",
    stroke: "url(#SVGID_4_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa",
    gradientUnits: "userSpaceOnUse",
    x1: 61.173,
    y1: 133.51,
    x2: 137.848,
    y2: 133.51
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.879 138.294H66.142a3.729 3.729 0 01-3.718-3.718v-2.131a3.729 3.729 0 013.718-3.718h66.738a3.729 3.729 0 013.718 3.718v2.131a3.73 3.73 0 01-3.719 3.718z",
    fill: "none",
    stroke: "url(#SVGID_5_1aafe7db63adef8996774d4923a5a9ae084eae9b7fd5dfa521e38ff5726cf6aa)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M77.411 99.463h-47.26l.002-.005v.078c0 6.6 5.4 12 12 12h23.255c6.6 0 12-5.4 12-12v-.078l.003.005zM168.708 99.463h-47.26l.002-.005v.078c0 6.6 5.4 12 12 12h23.255c6.6 0 12-5.4 12-12v-.078l.003.005z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.24807bb321df9cfcd988d655ddc01ac5.svg";
export { ForwardRef as ReactComponent };